import React from "react";

const ErrorDiv = (props) =>
{
    const style = {marginTop: '5px', color: 'red'};
    return <div style={style}>{props.children}</div>
}

export default ErrorDiv ;